
import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '@shared/ui/button';

interface OpenInNewTabProps {
  url: string;
  className?: string;
  children?: React.ReactNode;
}

const OpenInNewTab = ({ url, className, children }: OpenInNewTabProps) => {
  const handleOpenInNewTab = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Button 
      variant="outline" 
      size="sm" 
      className={className}
      onClick={handleOpenInNewTab}
    >
      {children || "Open in new tab"}
      <ExternalLink className="h-4 w-4 ml-2" />
    </Button>
  );
};

export default OpenInNewTab;
